import React, { type PropsWithChildren } from 'react';

type OfferingPackageInfoProps = PropsWithChildren<{
  heading: string;
  isUniversalPackage: boolean;
}>;

const OfferingPackageInfo: React.FC<OfferingPackageInfoProps> = ({
  heading,
  children,
  isUniversalPackage,
}) => {
  return (
    <>
      <hr className="my-8 md:my-12" />
      <div
        className={`flex flex-col items-start justify-center${isUniversalPackage ? ' px-4 lg:px-6' : ''}`}
      >
        <h2 className="text-2xl font-medium text-leland-gray-dark">
          {heading}
        </h2>
        <div className="mt-4">{children}</div>
      </div>
    </>
  );
};

export default OfferingPackageInfo;
